module.exports = __webpack_public_path__ + "static/media/4.6c7bdd78.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/4.png
// module id = 728
// module chunks = 0